import {
  currentIndexFromTmuaPhase,
  fromTmuaAlias,
  nextPearsonSittingPhase,
  toTmuaAlias,
  TMUA_EVENT_ALIASES,
} from './nextPearsonSittingPhase';

/**
 * 2-module adapter. String outputs for p1/p2 must match the shipped TMUA/LNAT player.
 */
export function nextTmuaPearsonPhase(phase, event, ctx = {}) {
  const genericPhase = fromTmuaAlias(phase);
  const genericEvent = TMUA_EVENT_ALIASES[event] || event;
  const next = nextPearsonSittingPhase(genericPhase, genericEvent, {
    ...ctx,
    moduleCount: 2,
    currentIndex: currentIndexFromTmuaPhase(phase),
    hasNext: ctx.hasP2,
    nextStatus: ctx.p2Status,
    siblingExpected: ctx.siblingExpected,
  });
  return toTmuaAlias(next);
}
